import React from 'react'
import Layout from '../components/layout'
import { VideoClip } from '../components/backgroundVideo'
import SEO from '../components/seo'
// import styles from './styles.module.css'
import TemplateDevlogIcon from '../templates/templateDevlogIcon'

export default () => {
    return (
        <Layout>
            <SEO 
                title='devlogs' 
                description="Insight into Outride's development"
                pathname='devlogs/'
            />
            <VideoClip clip='Road2'/>
            <TemplateDevlogIcon/>
        </Layout>
    )
}